import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { addComment, addReview, getReview } from './review.actions';
import { IReviewInitialState } from './review.interface';

const initialState: IReviewInitialState = {
  isLoading: false,
  commentId: 0,
  showCommentForm: false,
  showReviewComments: false,
  added_comment_id: 0,
  comments: null,
  review_comment_id: 0,
  reviews_comments_data: null,
  isAddedComment: false,
  isLikeReview: false,
  isLikeComment: false,
  focusForm: false,
  showComments: false,
  likesReviewData: {
    dislikes_count: '0',
    is_like_by_me: false,
    likes_count: '0',
  },
  likesCommentData: {
    dislikes_count: '0',
    is_like_by_me: false,
    likes_count: '0',
  },
  commentLikeId: 0,
  reviewsCommentsCount: 0,
  reviewStarsAvg: 0,
  formSubmitted: false,
};

const reviewSlice = createSlice({
  name: 'review',
  initialState,
  reducers: {
    setShowReviewComments(state, action: PayloadAction<boolean>) {
      state.showReviewComments = action.payload;
    },
    setShowCommentForm(state, action: PayloadAction<boolean>) {
      state.showCommentForm = action.payload;
    },
    setReviewId(state, action: PayloadAction<number>) {
      state.review_comment_id = action.payload;
    },
    setCommentId(state, action: PayloadAction<number>) {
      state.commentId = action.payload;
    },
    setCommentLikeId(state, action: PayloadAction<number>) {
      state.commentLikeId = action.payload;
    },
    setIsAddedComment(state, action: PayloadAction<boolean>) {
      state.isAddedComment = action.payload;
    },
    setIsLike(state, action: PayloadAction<boolean>) {
      state.isLikeReview = action.payload;
    },
    setIsLikeComment(state, action: PayloadAction<boolean>) {
      state.isLikeComment = action.payload;
    },
    setFocusForm(state, action: PayloadAction<boolean>) {
      state.focusForm = action.payload;
    },
    setShowComments(state, action: PayloadAction<boolean>) {
      state.showComments = action.payload;
    },
    getComments(state, action: PayloadAction<any>) {
      state.comments = action.payload;
    },
    setLikesReviewData(state, action) {
      state.likesReviewData = action.payload;
    },
    setLikesCommentData(state, action) {
      state.likesCommentData = action.payload;
    },
    setReviewCount(state, action) {
      state.reviewsCommentsCount = action.payload;
    },
    setReviewStars(state, action) {
      state.reviewStarsAvg = action.payload;
    },
    setFormSubmitted(state, action: PayloadAction<boolean>) {
      state.formSubmitted = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addReview.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addReview.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.review_comment_id = payload.review_comment_id;
      })
      .addCase(addReview.rejected, (state) => {
        state.isLoading = false;
        state.review_comment_id = 0;
      })
      .addCase(getReview.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getReview.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.reviews_comments_data = payload;
      })
      .addCase(getReview.rejected, (state) => {
        state.isLoading = false;
        state.reviews_comments_data = null;
      })
      .addCase(addComment.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(addComment.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.commentId = payload.review_comment_id;
        state.isAddedComment = true;
      })
      .addCase(addComment.rejected, (state) => {
        state.isLoading = false;
        state.commentId = 0;
      });
  },
});
export const reviewActions = reviewSlice.actions;
export const { reducer } = reviewSlice;
